import React from "react";
import { buttonVariants } from "../components/ui/button";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { PlusIcon } from "@radix-ui/react-icons";

const AddConsignorButton = () => {
  return (
    <Link
      href={`/consignors/add`}
      className={cn(buttonVariants({ variant: "default" }))}
    >
      <PlusIcon className="mr-2" />
      Add Consignor
    </Link>
  );
};

export default AddConsignorButton;
